import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { compose } from 'recompose';

import {
  selectIsVerifiedDependentRole,
  canEditNotJoinedPatient,
  isLoggedUserSelector,
  targetUserSelector,
} from '../../../redux/context/selectors';
import { selectCurrentCountryCode } from '../../../redux/profiles/selectors';
import { actions as editEmailActions } from '../../../redux/profiles/edit-email';
import { actions as editMobilePhoneActions } from '../../../redux/profiles/edit-mobile-phone';
import { actions as confirmMobilePhoneActions } from '../../../redux/profiles/confirm-mobile-phone';
import { actions as editPatientByProviderActions } from '../../../redux/profiles/edit-patient-by-provider';

import styles from '../index.styl';

const mapStateToProps = state => ({
  confirmMobilePhoneRequest: state.profiles.confirmMobilePhone,
  editMobilePhoneRequest: state.profiles.editMobilePhone,
  editEmailRequest: state.profiles.editEmail,
  canEdit: isLoggedUserSelector(state) || selectIsVerifiedDependentRole(state),
  canEditPatient: canEditNotJoinedPatient(state),
  profile: targetUserSelector(state),
  currentCountryCode: selectCurrentCountryCode(state),
});

const mapDispatchToProps = {
  updateEmail: editEmailActions.send,
  updateMobilePhone: editMobilePhoneActions.send,
  confirmMobilePhone: confirmMobilePhoneActions.send,
  clearMobilePhoneConfirmation: confirmMobilePhoneActions.clear,
  clearEmailRequest: editEmailActions.clear,
  clearPhoneRequest: editMobilePhoneActions.clear,
  savePatientByProvider: editPatientByProviderActions.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ContactInfoSection/enhance.js